import 'reflect-metadata';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {StyledEngineProvider} from '@mui/material';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';

import App from './App';
import store from './slices';

import {CssBaseline} from '@mui/material'; //сброс CSS вместо reset от antd
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import AuthWrapper from './components/AuthWrapper';
import {ThemeProviderWithI18n} from '@core/theme/theme';
import {QueryClientProvider} from '@tanstack/react-query';
import {client} from '@core/api/reactQueryClient';
import {NotificationsProvider} from '@features/notifications/NotificationsProvider';
import FullScreenLoader from '@ui/Loader/FullScreenLoader';
import {Notifications} from '@features/notifications/Notifications';
import {ErrorBoundary} from '@ui/ErrorBoundary/ErrorBoundary';
import './i18n';
import {AppUpdateProvider} from '@features/AppUpdateProvider/AppUpdateProvider';
import {AppUpdateDialog} from '@ui/AppUpdateDialog/AppUpdateDialog';
import {DynamicLocalizationProvider} from '@ui/LocalProvider/LocalProvider';
import {MessengerContextProvider} from '@features/Chat/context';
import {CallContextProvider} from '@features/Chat/CallContext';
import {GlobalIncomingCallModal} from '@features/Chat/components/GlobalIncomingCallModal';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
    weekStart: 1,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLDivElement);

root.render(
    <ErrorBoundary>
        <AppUpdateProvider>
            <AuthWrapper>
                <QueryClientProvider client={client}>
                    <StyledEngineProvider injectFirst>
                        <DynamicLocalizationProvider>
                            <ThemeProviderWithI18n>
                                <Provider store={store}>
                                    <NotificationsProvider>
                                        <CssBaseline />
                                        <FullScreenLoader />
                                        <Notifications />
                                        <MessengerContextProvider>
                                            <CallContextProvider>
                                                <App />
                                                <GlobalIncomingCallModal />
                                            </CallContextProvider>
                                        </MessengerContextProvider>
                                        <AppUpdateDialog />
                                    </NotificationsProvider>
                                </Provider>
                            </ThemeProviderWithI18n>
                        </DynamicLocalizationProvider>
                    </StyledEngineProvider>
                </QueryClientProvider>
            </AuthWrapper>
        </AppUpdateProvider>
    </ErrorBoundary>,
);
